'use client'

import { useEffect, useRef } from 'react'

export function ManifestLink() {
    const hasAddedRef = useRef(false)

    useEffect(() => {
        // Only add manifest link once, even if component re-renders
        if (hasAddedRef.current) return

        // Check if manifest link already exists
        const existingLink = document.querySelector('link[rel="manifest"]')
        if (!existingLink) {
            const link = document.createElement('link')
            link.rel = 'manifest'
            link.href = '/manifest.json'
            document.head.appendChild(link)
            hasAddedRef.current = true
        }
    }, [])

    return null
}
